import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporter({customer_id, agro_exporter_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/list_templates/agro_exporter/${customer_id}/${agro_exporter_id}`
    );
  },
  fetchContainer({customer_id, agro_exporter_id, container_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/list_templates/container/${customer_id}/${agro_exporter_id}/${container_id}`
    );
  },
  fetchTemplates({customer_id, agro_exporter_id, container_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/list_templates/${customer_id}/${agro_exporter_id}/${container_id}`
    );
  },
};
